import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import InputWrapper from './InputWrapper';

const PrimeDropdown = ({ value, options, onChange, placeholder, label, error, appendTo = "self" }) => {
  const optionTemplate = (option) => {
    return (
      <div className="d-flex align-items-center">
        {option.color && <div style={{ backgroundColor: option.color, width: '16px', height: '16px', marginRight: '8px' }} />}
        {option.value && <i className={`${option.value} me-2`} />}
        <span>{option.label}</span>
      </div>
    );
  };

  return (
    <InputWrapper label={label} error={error}>
      <Dropdown
        className="w-100"
        value={value}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        appendTo={appendTo}
        itemTemplate={optionTemplate}
      />
    </InputWrapper>
  );
};

export default PrimeDropdown;